import React, { useState, useEffect, useRef } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
// import makeStyles from "@mui/styles/makeStyles";
import { validateSecureLink, expireSecureLink } from "../_api/usersApi";
// import { validateSecureLink } from "../_api/usersApi";
import UnauthorizedCard from "./components/UnauthorizedCard";
import IdentityVerificationCard from "./components/IdentityVerificationCard";
import ThankYouCard from "./components/ThankYouCard";
import UpsertPaymentMethod from "./payments/UpsertPaymentMethod";
import { getPaymentMethod } from "../_api/paymentsApi";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";

const cardType = {
  thankYou: "ThankYou",
  unauthorized: "unauthorized",
  identityCard: "IdentityCard",
  payment: "Payment",
};

const AutoPayPage = () => {
  const [showCard, setShowCard] = useState(cardType.identityCard);
  const editItems = null;
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [user, setUser] = useState(null);
  const countInvalidResponse = useRef(0);
  const [submitting, setSubmitting] = useState(false);
  const token = useRef(null);
  const { t } = useTranslation();
  const cookies = new Cookies();

  useEffect(() => {
    cookies.remove("lifesaferUser", { path: "/" });
    const path = window.location.pathname;
    token.current = path.replace("/autopaysignup/", "");
    // token.current =
    //   "aDlnUWhFdHJOYVZxdzAvVmFXRHNDTmpmck9EbW5SRzcycGlpcEk5cEJwME5FL1RVc0VnY0xQYzN2QzJEYlVlaE5aNXhyYlB5YmRMVDdMdFdLQ2w1aGVmQmhJZEN6RkJU";
  }, []);

  useEffect(() => {
    if (user) {
      getPaymentMethod(user?.clientID)
        .then((x) => {
          setPaymentMethod(x);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }
  }, [user]);

  // useEffect(() => {
  //   if (user) {
  //     const url = `${process.env.API_URL}/PaymentMethods/${user?.clientID}`;

  //     fetch(`${url}`, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${user?.jwtToken}`,
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         setPaymentMethod(data);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // }, [user]);

  const handleIdentityVerification = (obj) => {
    setSubmitting(true);

    obj.token = token.current;
    validateSecureLink(obj)
      .then((x) => {
        cookies.set("lifesaferUser", JSON.stringify(x), {
          path: "/",
          sameSite: "strict",
        });
        setUser(x);
        setShowCard(cardType.payment);
      })
      .catch((error) => {
        setSubmitting(false);
        let errMess = error.message;
        errMess = errMess.split(":").pop().replace('"', "").slice(0, -2);
        toast.error(t("toasts.updateFailed") + " " + errMess);
        countInvalidResponse.current += 1;

        // expire link for 3 invalid response
        if (countInvalidResponse.current === 3) {
          secureLinkExpire();
          setShowCard(cardType.unauthorized);
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const secureLinkExpire = () => {
    let expireObj = {
      token: token.current,
      page: "My Account Auto Pay",
    };
    expireSecureLink(expireObj)
      .then((x) => {
        console.log("success", x);
      })
      .catch(() => {
        console.log("error");
      });
  };

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{paddingTop:"20px"}}
      >
        <Grid item>
          <img src={"./src/_images/LogoLimited.png"} alt="LifeSafer"/>
          <Typography
            variant="h4"
            sx={{
              // padding: "1rem",
              color: "#1c355e",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {t("registration.autoPayEnrollment")}

          </Typography>

          {showCard === "Payment" && (
            <Typography
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                color: "rgb(28, 53, 94)",
                fontSize: "20px",
              }}
            >
              {t("securepay.client")} {user?.clientName || "N/A"}
            </Typography>
          )}
        </Grid>

        {/* <Grid container 
                sx={{width:'40%'}}
                justifyContent="center"
                > */}
        {showCard == "IdentityCard" && (
          <IdentityVerificationCard
            handleIdentityVerification={handleIdentityVerification}
            submitting={submitting}
          />
        )}

        {showCard == "unauthorized" && <UnauthorizedCard />}

        {showCard == "ThankYou" && <ThankYouCard />}

        {showCard == "Payment" && (
          <UpsertPaymentMethod
            user={user}
            items={editItems}
            paymentMethod={paymentMethod}
            setShowCard={setShowCard}
            secureLinkExpire={secureLinkExpire}
            cookies={cookies}
            // editCancel={onEditCancel}
          />
        )}

        {/* </Grid> */}
      </Grid>
    </>
  );
};

export default AutoPayPage;
